"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _rootReducer = _interopRequireDefault(require("../../astercore/common/redux/rootReducer"));
var _rootReducer2 = _interopRequireDefault(require("../../teleconsultant/common/redux/rootReducer"));
var _rootReducer3 = _interopRequireDefault(require("../../epharmacy/common/redux/rootReducer"));
var _epharmacyNotPersistReducer = _interopRequireDefault(require("../../epharmacy/common/redux/epharmacyNotPersistReducer"));
var _rootReducer4 = _interopRequireDefault(require("../../DOD/common/redux/rootReducer"));
var _rootReducer5 = _interopRequireDefault(require("../../homecare/common/redux/rootReducer"));
var _const = require("./const");
// Imports: Dependencies
// Imports: Reducers
// Redux: Root Reducer
// const rootReducer = combineReducers({
//     astercore: astercore
// });
// Exports
var _default = exports.default = {
  [_const.ASTER_CORE_REDUCER]: _rootReducer.default,
  [_const.TELE_CONSULTANT_REDUCER]: _rootReducer2.default,
  [_const.EPHARMACY_REDUCER]: _rootReducer3.default,
  [_const.EPHARMACY_NOT_PERSIST_REDUCER]: _epharmacyNotPersistReducer.default,
  [_const.DOD_REDUCER]: _rootReducer4.default,
  [_const.HOMECARE_REDUCER]: _rootReducer5.default
};